module.exports = __webpack_public_path__ + "img/dribbble.b463b292.png";